import { render, staticRenderFns } from "./addHouse.vue?vue&type=template&id=6370239e&scoped=true&"
import script from "./addHouse.vue?vue&type=script&lang=js&"
export * from "./addHouse.vue?vue&type=script&lang=js&"
import style0 from "./addHouse.vue?vue&type=style&index=0&id=6370239e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370239e",
  null
  
)

export default component.exports